import styled from 'styled-components'

export default styled.section`
  max-width: 800px;
  width: 100%;
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .spinner-container {
    flex: 1;
  }

  .tabs {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 24px;
    border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };

    button {
      flex: 1;
      background: none;
      border: none;
      border-bottom: 3px solid transparent;
      padding: 12px 8px;
      cursor: pointer;
      font-family: inherit;
      font-size: 15px;
      font-weight: 600;
      text-transform: uppercase;
      color: ${ ({ theme }) => theme.colors.greyDark };

      &.active {
        color: ${ ({ theme }) => theme.colors.primary };
        border-bottom-color: ${ ({ theme }) => theme.colors.primary };
      }
    }
  }

  .favorites {
    width: 100%;
    height: 100%;
    overflow-x: visible;
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    > section:last-of-type {
      margin-bottom: 50px;
    }

    .spinner-container {
      flex: 1;
      &.more {
        height: auto;
        position: fixed;
        bottom: 100px;
        left: 0;
        right: 0;
      }
    }
  }

  .empty-reservations {
    margin-top: 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 348px;
      height: auto;
      margin-bottom: 72px;
    }

    h3,
    p {
      margin: 0;
      color: ${ ({ theme }) => theme.colors.grey };
    }

    h3 {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 20px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 15px;
      text-align: center;
    }
  }
`
